import {
  createApiClient,
  getHeader,
  getOrganizationIdParamString,
  handleError,
  handleResponse
} from '@/helpers/api'
import store from '@/store'
import { EventBus } from '@/helpers/eventBus'

const apiUploadClient = createApiClient(
  window.config.VUE_APP_UPLOAD_API_BASE_URL
)

//EXPORTS
export const uploadService = {
  uploadFile,
  deleteFile,
  validation,
  getDocuments,
  editMetaData,
  getFileMetaData,
  getDocumentImage,
  getDocument,
  confirmWarnings,
  putTestDocument,
  getTestFile,
  putTestFile,
  postTestFile,
  cancelUpload,
  addAttachments,
  deleteAttachments
}

// API CALLS
function getDocumentImage(id, pageNumber) {
  const queryParams = new URLSearchParams({
    quality: 100,
    stampArea: pageNumber == 0,
    addressArea: pageNumber == 0,
    pageNumber
  }).toString()

  return apiUploadClient
    .get(`/Document/${id}/image?${queryParams}`)
    .then(handleResponse)
    .catch(handleError)
}

async function getDocument(id) {
  return apiUploadClient
    .get(`/Document/${id}`)
    .then(handleResponse)
    .catch(handleError)
}

async function getFileMetaData(id) {
  return apiUploadClient
    .get(`/Document/Meta/${id}`)
    .then(handleResponse)
    .catch(handleError)
}

async function confirmWarnings(payload) {
  return apiUploadClient
    .put(`/document/confirmWarnings${getOrganizationIdParamString()}`, payload)
    .then(handleResponse)
    .catch(handleError)
}

async function getDocuments(uploadFileId) {
  return apiUploadClient
    .get(`/File/${uploadFileId}/documents`)
    .then(handleResponse)
    .catch(handleError)
}

async function deleteFile(payload) {
  return apiUploadClient
    .delete('/File', getHeader({ data: payload.uploadFileIds }))
    .then(handleResponse)
    .catch(handleError)
}

async function putTestDocument(payload) {
  return apiUploadClient
    .put('/File/testdocument', payload)
    .then(handleResponse)
    .catch(handleError)
}

async function getTestFile(payload) {
  return apiUploadClient
    .get(`/File/testfile?scaling=${payload.scaling}`)
    .then(handleResponse)
    .catch(handleError)
}

async function putTestFile(payload) {
  return apiUploadClient
    .put(`/File/testfile?scaling=${payload.scaling}`, payload.userData)
    .then(handleResponse)
    .catch(handleError)
}

async function postTestFile(payload) {
  return apiUploadClient
    .post('/File/testfile/send', payload.userData, {
      headers: {
        Authorization: 'bearer ' + payload.jwt
      }
    })
    .then(handleResponse)
    .catch(handleError)
}

async function uploadFile(payload, cancelToken) {
  return apiUploadClient
    .post(`/FileUpload${getOrganizationIdParamString()}`, payload.formData, {
      headers: {
        Authorization: 'bearer ' + store.getters.jwt,
        userSettings: payload.userSettings
      },
      cancelToken: cancelToken.token,
      onUploadProgress: function(progressEvent) {
        /* istanbul ignore next */
        const uploadPercentage = parseInt(
          Math.round((progressEvent.loaded / progressEvent.total) * 100)
        )
        /* istanbul ignore next */
        EventBus.$emit(
          'uploadPercentage-' +
            payload.fileParams.fileName +
            '' +
            payload.fileParams.timestamp,
          uploadPercentage
        )
      }
    })
    .then(handleResponse)
    .catch(handleError)
}

async function editMetaData(id, payload) {
  return apiUploadClient
    .put(`/FileMetaData/${id}`, payload)
    .then(handleResponse)
    .catch(handleError)
}

function validation(args) {
  return apiUploadClient
    .post('/Validation', { orderIds: args.orderIds })
    .then(handleResponse)
    .catch(handleError)
}

async function addAttachments(payload, cancelToken) {
  return apiUploadClient
    .post(
      `/Attachments${getOrganizationIdParamString()}`,
      payload,
      getHeader(
        {
          cancelToken: cancelToken.token,
          onUploadProgress: function(progressEvent) {
            /* istanbul ignore next */
            const uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            )
            /* istanbul ignore next */
            EventBus.$emit('uploadPercentage', uploadPercentage)
          }
        },
        'multipart/form-data'
      )
    )
    .then(handleResponse)
    .catch(handleError)
}

async function deleteAttachments(payload) {
  return apiUploadClient
    .delete(
      `/Attachments${getOrganizationIdParamString()}`,
      getHeader({
        data: {
          documentId: payload.documentId,
          attachmentIds: payload.attachmentIds,
          orderId: payload.orderId
        }
      })
    )
    .then(handleResponse)
    .catch(handleError)
}

// HELPERS
async function cancelUpload(cancelToken) {
  cancelToken && cancelToken.cancel('Operation canceled by the user.')
}
